/**
 * Maps ISO standard slugs to their course-level URLs.
 * Used by ISOProgressionPath and RelatedCoursesSection components.
 */
export const courseRoutes = {
  'iso-9001': {
    awareness: '/ISO-9001-Awareness-Training',
    internalAuditor: '/Internal-Auditor-ISO-9001-Training',
    leadAuditor: '/Lead-Auditor-Certification-ISO-9001',
  },
  'iso-14001': {
    awareness: '/ISO-14001-Awareness-Training',
    internalAuditor: '/ISO-14001-Internal-Auditor-Course',
    leadAuditor: '/ISO-14001-Lead-Auditor-Course',
  },
  'iso-27001': {
    awareness: '/ISO-27001-Awareness-Training',
    internalAuditor: '/ISO-27001-Internal-Auditor-Course',
    leadAuditor: '/ISO-27001-Lead-Auditor-Course',
  },
  'iso-45001': {
    awareness: '/ISO-45001-Awareness-Training',
    internalAuditor: '/ISO-45001-Internal-Auditor-Training',
    leadAuditor: '/ISO-45001-Lead-Auditor-Course',
  },
  'iso-13485': {
    awareness: '/ISO-13485-Awareness-Training',
    internalAuditor: '/ISO-13485-Internal-Auditor-Training',
    leadAuditor: '/ISO-13485-Lead-Auditor-Training',
  },
  'iso-21001': {
    awareness: '/ISO-21001-Awareness-Training',
    internalAuditor: '/ISO-21001-Internal-Auditor-Training',
    leadAuditor: '/ISO-21001-Lead-Auditor-Training',
  },
  'iso-22000': {
    awareness: '/ISO-22000-Awareness-Training',
    internalAuditor: '/ISO-22000-Internal-Auditor-Training',
    leadAuditor: '/ISO-22000-Lead-Auditor-Course',
  },
  'iso-50001': {
    awareness: '/ISO-50001-Awareness-Training',
    internalAuditor: '/ISO-50001-Internal-Auditor-Course',
    leadAuditor: '/ISO-50001-Lead-Auditor-Course',
  },
  'iatf-16949': {
    awareness: '/IATF-16949-Awareness-Training',
    internalAuditor: '/IATF-16949-Internal-Auditor-Training',
    leadAuditor: '/IATF-16949-Lead-Auditor-Course',
  },
};

/**
 * Groups ISO standards by relevance for the Related Courses section.
 * Each array lists 3 slugs that are most contextually related.
 */
export const relatedStandards = {
  'iso-9001':   ['iso-14001', 'iso-45001', 'iatf-16949'],
  'iso-14001':  ['iso-9001', 'iso-45001', 'iso-50001'],
  'iso-45001':  ['iso-9001', 'iso-14001', 'iso-13485'],
  'iso-27001':  ['iso-9001', 'iso-13485', 'iso-22000'],
  'iatf-16949': ['iso-9001', 'iso-14001', 'iso-45001'],
  'iso-13485':  ['iso-9001', 'iso-45001', 'iso-27001'],
  'iso-22000':  ['iso-9001', 'iso-14001', 'iso-45001'],
  'iso-50001':  ['iso-14001', 'iso-9001', 'iso-45001'],
  'iso-21001':  ['iso-9001', 'iso-14001', 'iso-45001'],
};
